/** @jsxImportSource @emotion/react */
import { Icon } from '@ssmm/ui';
import { colors, HeadingH3, Text } from 'components/landing/ui';
import { arrowRight } from 'components/landing/ui/icons';

const Case = ({ target, onClick }) => {
  const { title, background } = target;

  return (
    <div key={title} css={{ position: 'relative' }}>
      <div
        onClick={onClick}
        css={{
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundImage: `url(${background[0]})`,
          borderRadius: 4,
          cursor: 'pointer',
          marginBottom: 10,
          flexGrow: 1,
          width: '100%',
          height: 230,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          transition: '0.5s',
          filter: 'grayscale(1)',
          ':hover': { filter: 'grayscale(0)' },
          '@media (-webkit-min-device-pixel-ratio: 2)': {
            backgroundImage: `url(${background[1]})`,
          },
          '@media (-webkit-min-device-pixel-ratio: 3)': {
            backgroundImage: `url(${background[2]})`,
          },
          '@media (min-width:768px)': {
            height: 358,
          },
          '@media (min-width:992px)': {
            height: 200,
            ':hover': { height: 230, top: -30 },
          },
        }}
      />

      <div
        css={{
          alignItems: 'center',
          justifyContent: 'space-between',
          '@media (min-width:768px)': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
          },
        }}
      >
        <HeadingH3>{title}</HeadingH3>
        <div
          onClick={onClick}
          css={{
            alignItems: 'center',
            cursor: 'pointer',
            ':hover': { span: { color: colors.blue } },
          }}
        >
          <Text css={{ color: colors.grayLight, marginRight: 10, transition: '0.2s' }}>
            Узнать больше
          </Text>
          <Icon svg={arrowRight} color={colors.blue} />
        </div>
      </div>
    </div>
  );
};

export default Case;
